export default "__VITE_ASSET__VSO66OC___"